import { Command } from '@/app/tracking/api';

export const CloseCourseCommandName = 'close-course' as const;
export type CloseCourseCommand =
      Command<typeof CloseCourseCommandName, {}>;
